import { InteractiveContainer } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import { FC } from "react";

interface BoardPillProps {
  title: string;
  isSelected: boolean;
  onClick: () => void;
}

export const BoardPill: FC<BoardPillProps> = ({
  title,
  isSelected,
  onClick,
}) => (
  <InteractiveContainer
    className={cx(
      "max-w-[140px] shrink-0 truncate rounded-lg bg-grey-100 px-4 py-[5px] transition-colors",
      isSelected && "bg-primary"
    )}
    onClick={onClick}
  >
    <span
      className={cx(
        "font-secondary text-[13px] leading-2 text-dark-700 transition-colors",
        isSelected && "font-medium text-white"
      )}
    >
      {title}
    </span>
  </InteractiveContainer>
);
